import { v4 as uuidv4 } from 'uuid';
import { isBrowser } from './isBrowser';
import { EPayContext } from '../../interfaces';

const GTB_UUID_LOCAL_STORAGE_KEY = 'FFF_gtb_uuid';
const SHOP_UUID_LOCAL_STORAGE_KEY = 'FFF_pandora_uuid';
const gtbPage = 'gtb';

export const getUUID = (payContext: EPayContext): string => {
  if (!isBrowser()) {
    return '';
  }
  const prospectUuid = payContext === gtbPage ? GTB_UUID_LOCAL_STORAGE_KEY : SHOP_UUID_LOCAL_STORAGE_KEY;
  const uuidFromLocalStorage = localStorage.getItem(prospectUuid);
  if (!uuidFromLocalStorage) {
    const uuid = uuidv4();
    localStorage.setItem(prospectUuid, uuid);
    return uuid;
  }
  return uuidFromLocalStorage;
};
